import createNamedContext from 'utils/createNamedContext';

export const DialogueModeContext = createNamedContext<'faq' | null>('DialogueModeContext', null);
